import PropTypes from 'prop-types';
import ExtraPropTypes from 'react-extra-prop-types';

export default PropTypes.shape({
  uuid: ExtraPropTypes.uuid.isRequired,
  // app: PropTypes.string.isRequired, // not present in the app sub-request

  name: PropTypes.string,
  desc: PropTypes.string,
  images: PropTypes.string, // Not required from UX perspective. Some users may choose not to use this features.

  tags: PropTypes.arrayOf(PropTypes.string),
});
